<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="900px"
      v-bind:body-style="{ height: '450px' }"
    >
    <!-- 内容 -->
    <div class="investment_warp">
      <SearchHunt
        :filterData="filterData"
        @handle_seach="handle_seach"
        @handle_add="handle_add(null,1)"
        ref="SearchHunt"
      />
      <a-table
        :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange , columnWidth: '40px'}"
        class="antd-table"
        bordered
        :columns="relevanceBatch_grid.field"
        :data-source="relevanceBatch_grid.row"
        rowKey="id"
        size="small"
        :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
        :pagination="false"
      >
        <!-- 序号 -->
        <span slot="index" slot-scope="text, record, index">
          {{index + (pageParam.pageNum-1) * pageParam.pageSize + 1}}
        </span>
        <!-- 商品类型 -->
        <span slot="goodsType" slot-scope="text, record">
          {{ text | DictionaryFilter('GOODS_TYPE') }}
        </span>
        <!-- 有效期 -->
        <span slot="expiryDate" slot-scope="text, record">
          {{ text | DictionaryFilter('GOODS_EXPIRY_DATE') }}
        </span>
      </a-table>

      <!-- 底部 -->
      <div class="table_bottom">
        <!-- 按钮 -->
        <!-- <div class="bottom_btn">
          <a-button type="primary" @click="handle_all" class="btn_first">选择全部</a-button>
          <a-button type="primary" ghost  @click="handle_reverse">反向选择</a-button>
        </div> -->

        <!-- 分页 -->
        <div>
          <a-pagination
            class="table_pagination"
            show-size-changer
            :default-current="1"
            v-model="pageParam.pageNum"
            :show-total="(total) => `共 ${total} 条`"
            :page-size-options="pageSizeOptions"
            size="small"
            :total="total"
            @showSizeChange="onShowSizeChange"
            @change="paginationChange"
            :page-size.sync="pageParam.pageSize"
          />
        </div>
      </div>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import {
  goodList
} from "@/api/api.js";
import { DictionaryService } from "@common/services/dictionary.service";
import SearchHunt from "../search-hunt/select-search-hunt.vue";
export default {
  components: {
    SearchHunt,
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "撤销赎回",
    }, //标题
    modalContent: {
      type: String,
      default: () => "是否确认撤销赎回？",
    }, //内容
    data: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      visible: true,

      //搜索栏
      filterData: [
        {
          name: "goodsName",
          type: "input",
          value: undefined,
          label: "请输入商品名称",
          placeholder:"商品名称：",
        },
      ],
      relevanceBatch_grid: {
        height: "280px",
        width: 0, // 宽度
        row: [
        ],
        field: [
        {
            title: "序号",
            align: "center",
            width: 45,
            dataIndex: "index",
            ellipsis: true,
            scopedSlots: {
              customRender: "index",
            },
          },
          {
            title: "商品名称",
            align: "center",
            width: 150,
            dataIndex: "goodsName",
            ellipsis: true,
          },
          {
            title: "商品定价",
            align: "center",
            width: 150,
            dataIndex: "goodsPrice",
            ellipsis: true,
          },
          {
            title: "商品类型",
            align: "center",
            width: 150,
            dataIndex: "goodsType",
            ellipsis: true,
            scopedSlots: {
              customRender: "goodsType",
            },
          },
          {
            title: "有效期",
            align: "center",
            width: 120,
            dataIndex: "expiryDate",
            ellipsis: true,
            scopedSlots: {
              customRender: "expiryDate",
            },
          },
        ]
      },
      pageParam: {
        pageNum: 1,
        pageSize: 10,
        orderBy: ""
      },
      pageSizeOptions: ["10", "20", "50", "100"],
      total: 0,
      paramsObj: {
        goodsCode: null,
        goodsName: null,
        goodsStatus:"1", //商品状态-默认
      },
      list: [],
      selectedRows: [],//多选数据
      selectedRowKeys: [],
      okLoad: false,
    }
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["GOODS_TYPE","GOODS_EXPIRY_DATE"]).then((res) => {
      //查询
      this.queryList();
    }); 
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      if (this.selectedRows.length == 0) {
        this.$message.warning("请选择一条数据！")
      } else {
        this.okLoad = true
        this.$emit("handleOk",this.selectedRows); 
      }
    },

    paginationChange(page, pageSize) {
      this.pageParam.pageNum = page;
      this.queryList();
    },
    onShowSizeChange(current, size) {
      this.pageParam.pageSize = size;
      this.pageParam.pageNum = 1;
      this.queryList();
    },

    onSelectChange(data, selectedRows) {
      this.selectedRows = selectedRows;
      this.selectedRowKeys = data;
    },

    // 查询
    handle_seach(params) {
      this.paramsObj = params;
      this.paramsObj['goodsStatus'] = '1';
      this.pageParam.pageNum = 1;
      this.queryList();
    },
    queryList() {
      goodList({
        pageParam: {
          pageNum: this.pageParam.pageNum,
          pageSize: this.pageParam.pageSize,
          orderBy: ""
        },
        content: this.paramsObj
      })
      .then(res => {
        if (res.content.rows && res.content.rows.length) {
          this.relevanceBatch_grid.row = res.content.rows;
          this.total = res.content.page.totalRows;
        } else {
          this.relevanceBatch_grid.row = [];
          this.total = 0;
        }
      });
    },

    

  },
}
</script>

<style scoped lang="less">

.message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
}

.table_bottom{
  float: right;
  margin-top: 10px;

.bottom_btn{
  margin-top: 10px;

  .btn_first{
    margin-right: 10px;
  }
}



}
</style>
